export const convertStringValueToPixels = (breakpoint: string): number => {
  const lowercasedBreakpoint = breakpoint.toLowerCase();
  if (!lowercasedBreakpoint.match(/[0-9]+px$/))
    throw new Error(
      `The input "${breakpoint}" cannot be converted. The input must be a a string containing a number and followed by "px" e.g. "100px"`,
    );

  return Number(lowercasedBreakpoint.replace('px', ''));
};
